import { render, staticRenderFns } from "./register.html?vue&type=template&id=8c735dcc&scoped=true&"
import script from "./register.js?vue&type=script&lang=js&"
export * from "./register.js?vue&type=script&lang=js&"
import style0 from "./register.scss?vue&type=style&index=0&id=8c735dcc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c735dcc",
  null
  
)

export default component.exports